import React from 'react';
const items = ['RECIBÍS AL INSTANTE VIA MAIL 📬', 'INSPIRADOS EN HECHOS REALES 🔥', 'JUEGOS DIGITALES 💻', 'GARANTÍA 30 DÍAS ✓', 'PAGO SEGURO 🔒', 'RECIBÍS AL INSTANTE VIA MAIL 📬', 'INSPIRADOS EN HECHOS REALES 🔥', 'JUEGOS DIGITALES 💻', 'GARANTÍA 30 DÍAS ✓', 'PAGO SEGURO 🔒'];
export function MarqueeBanner() {
  return <div className="fixed top-0 left-0 right-0 z-50 overflow-hidden" style={{
    backgroundColor: '#7b1111',
    height: '36px',
    borderBottom: '1px solid #9b1c1c'
  }} data-id="element-174">
      <style data-id="element-175">{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          width: max-content;
          animation: marquee 28s linear infinite;
        }
      `}</style>
      <div className="marquee-track h-full items-center flex" data-id="element-176">
        {[...items, ...items].map((item, i) => <span key={i} className="text-white font-black text-xs tracking-widest uppercase whitespace-nowrap" style={{
        padding: '0 3rem',
        fontFamily: "'Inter', sans-serif"
      }} data-id="element-177">
            {item}
          </span>)}
      </div>
    </div>;
}